import React from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css'
import moment from 'moment'

interface CustomDatePickerProps {
  dateRange: { startDate: Date | null; endDate: Date | null };
  onDateChange: (dates: [Date | null, Date | null]) => void;
  classCustom?: string;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({ dateRange, onDateChange, classCustom }) => {
  const { startDate, endDate } = dateRange;

  const handleApply = (event: any, picker: any) => {
    onDateChange([picker.startDate.toDate(), picker.endDate.toDate()]);
  };

  const label = startDate && endDate 
    ? `${moment(startDate).format('YYYY-MM-DD')} - ${moment(endDate).format('YYYY-MM-DD')}` 
    : 'Select date range';

  return (
    <div className="datepicker-container-fix">
      {/* @ts-ignore */}
      <DateRangePicker
        initialSettings={{
          startDate: startDate || undefined,
          endDate: endDate || undefined,
          locale: {
            format: 'YYYY-MM-DD',
            cancelLabel: 'Clear'
          },
          ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'This Week': [moment().startOf('week'), moment().endOf('week')],
            'Last Week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
          },
          showDropdowns: true, 
          alwaysShowCalendars: true,
        }}
        onApply={handleApply}
        onCancel={() => onDateChange([null, null])}
      >
        <div className="input-group cursor-pointer">
          <input
            type="text"
            className={`form-control date-input cursor-pointer ${classCustom}`}
            value={label}
            readOnly
          />
          <span className="input-group-text">
            <i className="bi bi-calendar3"></i> 
          </span>
        </div>
      </DateRangePicker>
    </div>
  );
};

export { CustomDatePicker };